import { useState } from 'react';

import { produce } from 'immer';

export default function CustomStylesInput({ styleObj = {}, setStyle, styles }) {
  const [newKey, setNewKey] = useState('');
  const [newValue, setNewValue] = useState('');

  const handleKeyChange = (oldKey, newKeyValue) => {
    if (!newKeyValue) return;
    setStyle(
      produce(styles, (draft) => {
        draft.custom[newKeyValue] = draft.custom[oldKey];
        delete draft.custom[oldKey];
      }),
    );
  };

  const handleValueChange = (key, value) => {
    setStyle(
      produce(styles, (draft) => {
        draft.custom[key] = value;
      }),
    );
  };

  const handleRemove = (key) => {
    setStyle(
      produce(styles, (draft) => {
        delete draft.custom[key];
      }),
    );
  };

  const handleAdd = () => {
    if (!newKey) return;
    setStyle(
      produce(styles, (draft) => {
        draft.custom[newKey] = newValue;
      }),
    );
    setNewKey('');
    setNewValue('');
  };

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex">
        <span className="text-muted">
          Enter in your custom CSS variables here, please make sure they are in snake case (e.g., "my-custom-class" will become "--my-custom-class").
        </span>
      </div>
      {Object.entries(styleObj).map(([key, value]) => (
        <div key={key} className="d-flex align-items-center gap-2">
          <input className="form-control" style={{ maxWidth: 150 }} value={key} onChange={(e) => handleKeyChange(key, e.target.value)} placeholder="Key" />
          <input className="form-control" value={value} onChange={(e) => handleValueChange(key, e.target.value)} placeholder="Value" />
          <button className="btn btn-outline-danger btn-sm" type="button" onClick={() => handleRemove(key)} title="Remove">
            <i className="fe fe-x" />
          </button>
        </div>
      ))}
      <div className="d-flex align-items-center gap-2 mt-2">
        <input className="form-control" style={{ maxWidth: 150 }} value={newKey} onChange={(e) => setNewKey(e.target.value)} placeholder="New key" />
        <input className="form-control" value={newValue} onChange={(e) => setNewValue(e.target.value)} placeholder="New value" />
        <button className="btn btn-outline-primary btn-sm" type="button" onClick={handleAdd} disabled={!newKey}>
          Add
        </button>
      </div>
    </div>
  );
}
